import { useEffect } from "react";
import { track } from "../firebase";
import type { Variant } from "../lp/types";

/**
 * タイトルの設定と、GA4 への画面表示イベント送信。
 * variant をパラメータに載せることで、GA4 側で A/B の比較ができます。
 */
export function usePageSetup(variant: Variant) {
  useEffect(() => {
    document.title = "ドライバー求人 無料登録｜Workful";
    void track("page_view", {
      page_title: document.title,
      page_location: location.href,
      variant,
    });
  }, [variant]);
}
